import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Button, Modal, Menu, Avatar } from 'antd'
import { app, use, config } from 'xadmin'
import MenuEditTree from '../components/MenuEditTree'
import { Icon, Loading } from 'xadmin-ui'
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import './style.css'
import SelectMenu from './SelectMenu'
import { onAuthorization } from '../components/util'

const SettingsMenuField = ({ input }) => {

  const [visible, setVisible] = useState(false)

  const showModal = () => setVisible(true)

  const handleOk = e => {
    setVisible(false)
  }

  const handleCancel = e => setVisible(false)

  return (
    <div>
      <Button onClick={showModal}><Icon type="setting" /></Button>
      <Modal title={<span style={{ padding: '.5rem' }}></span>} width={800} bodyStyle={{ padding: 20 }} footer={null} visible={visible} onOk={handleOk} onCancel={handleCancel}>
        <MenuEditTree input={input} handleCancel={() => { }} />
      </Modal>
    </div>
  )
}

const MainMenu = (props) => {
  const { canClick = true, menu, update, data, inlineCollapsed, defaultOpenKeys, accordion, mode, cellKey, editMode } = props

  const { width = '100%', trigger, bgColor, textSize, textColor, icon, itemHeight, itemMargin, childItemMargin, childItemHeight, } = props.config
  const { user, user: { permissions, rolesObjList } } = use('redux', state => ({ user: state.user }))
  // 菜单icon 和icon + 文字 模式切花
  const [collapsed, setCollapsed] = React.useState(false);
  const [openKeys, setOpenKeys] = React.useState([])
  const [selectedKeys, setSelectedKeys] = React.useState([])
  const isSuper = user?.isSuper || user?.isAdmin
    ;
  let value = menu

  if (!isSuper) {
    const configMenu = menu
    const userMenu = user?.mainmenu
    const rolesMenu = rolesObjList && rolesObjList.length > 0 ? rolesObjList
      .map(role => role.mainmenu ? role.mainmenu : [])
      .reduce((prev, role) => (_.unionBy(prev, role, 'title')), [])
      : null

    const mergeMenu = userMenu && userMenu.length > 0 ? userMenu : rolesMenu
    value = mergeMenu && mergeMenu.length > 0 ? _.intersectionBy(configMenu, mergeMenu, 'title') : configMenu

  }

  const MenuClick = (item) => {
    const { url, iframUrl } = item
    const { hash } = window.location
    if (hash == `#${url}`) return
    if (url && canClick) {
      window.__history__ = _.compact(_.uniqBy([...(window.__history__ || []), item], 'key'))
      if (url.indexOf('http') >= 0) {
        if (iframUrl) {
          update((state) => {
            return {
              ...state,
              ['menuforIfram']: url
            }
          })
        } else {
          window.open(url)
        }
      } else {
        if (!iframUrl) {
          app.go(url)
        } else {
          update((state) => {
            return {
              ...state,
              ['menuforIfram']: url
            }
          })
        }
      }
    }
  }

  const menustyle = { color: textColor }
  const style = { margin: `0 ${itemMargin}px`, fontSize: textSize }

  const GetMenu = (menuTreeData) => {
    if (!menuTreeData || _.isEmpty(menuTreeData)) return
    return menuTreeData.map(item => {
      let titileIcon = <span className="dashboar_menu"><img /></span>
      let src = item.icon
      if (src) {
        if (_.isString(src) && src.indexOf('/') > -1) {
          titileIcon = <span className="dashboar_menu"><img src={config('mediaUrl') + src} /></span>
        } else {
          const icons = app.get('icons')
          const icon = _.find(icons, item => item.name == src)
          if (icon) { titileIcon = <Icon svg={icon.url} /> } else { titileIcon = item.icon }
        }
      }
      if (item.iframUrl && item.url.indexOf('fullscreen=true&loadwarning=false') == -1) {
        if (item.url.indexOf('?') == -1 && item.url.indexOf('/fullscreen/') == -1) {
          item.url = item.url
        } else if (item.url.indexOf('?') != -1 && item.url.indexOf('/fullscreen/') == -1) {
          item.url = item.url + '&newData.url'
        }
      }
      if (!onAuthorization(item.permission)) {
        return null
      }
      if (item.children && item.children.length > 0) {
        return (
          <Menu.SubMenu title={
            <a onClick={() => (item.url || item.iframUrl) && MenuClick(item)}
              style={style}>
              {icon ? titileIcon : null}
              <span style={menustyle}>{item.title}</span>
            </a>}
            popupClassName={'dashboar_menu_popup'}
            key={item.key}
          >
            {GetMenu(item.children)}
          </Menu.SubMenu>
        )
      }
      return (
        <Menu.Item key={item.key} onClick={() => window.__history__ = _.compact(_.uniqBy([...(window.__history__ || []), item], 'key'))}>
          <a onClick={() => (item.url || item.iframUrl) && MenuClick(item)} style={style}>
            {icon ? titileIcon : null}
            <span style={{ ...menustyle }}>{item.title}</span>
          </a>
        </Menu.Item>
      )
    })
  }

  const onSelect = ({ selectedKeys }) => {
    setSelectedKeys(selectedKeys)
    localStorage.setItem(`menu_sled_${cellKey}`, JSON.stringify(selectedKeys))
  }

  const onOpenChange = (keys) => {
    let opks = keys
    if (accordion) {
      const subkeys = menu.map(item => { return item.key })
      const latestOpenKey = keys.find((key) => openKeys?.indexOf(key) === -1);
      if (subkeys.indexOf(latestOpenKey) === -1) {
        opks = keys;
      } else {
        opks = latestOpenKey ? [latestOpenKey] : []
      }
    }
    setOpenKeys(opks)
    localStorage.setItem(`menu_opks_${cellKey}`, JSON.stringify(opks))
  }

  const onToggleCollapsed = () => {
    setCollapsed(!collapsed)
    localStorage.setItem(`menu_colp_${cellKey}`, JSON.stringify(!collapsed))
  };

  React.useEffect(() => {
    const lsSelected = localStorage.getItem(`menu_sled_${cellKey}`)
    const lsOpenKeys = localStorage.getItem(`menu_opks_${cellKey}`)
    const lsColp = localStorage.getItem(`menu_colp_${cellKey}`)
    try {
      const s = JSON.parse(lsSelected)
      const o = JSON.parse(lsOpenKeys)
      const c = JSON.parse(lsColp)
      o && setOpenKeys(o)
      s && setSelectedKeys(s)
      c && setCollapsed(c)
    } catch (error) { }
    return () => {
      localStorage.removeItem(`menu_sled_${cellKey}`)
      localStorage.removeItem(`menu_opks_${cellKey}`)
      localStorage.removeItem(`menu_colp_${cellKey}`)
    }
  }, [])

  React.useEffect(() => {
    if (defaultOpenKeys && editMode) {
      setOpenKeys(_.isArray(defaultOpenKeys) ? defaultOpenKeys : [defaultOpenKeys])
    }
  }, [defaultOpenKeys])

  React.useEffect(() => {
    if (defaultOpenKeys && !editMode) {
      setOpenKeys(_.isArray(defaultOpenKeys) ? defaultOpenKeys : [defaultOpenKeys])
    }
  }, [])


  React.useEffect(() => {
    const handleRouteChange = () => {
      const currentPath = window.location.hash.substring(1);
      const selectedMenu = findSelectedKeyByPath(menu, decodeURI(currentPath));
      const selectedKey = selectedMenu?.key
      setSelectedKeys(selectedKey ? [selectedKey] : []);
      window.__history__ = _.compact(_.uniqBy([...(window.__history__ || []), selectedMenu], 'key'))
    };

    handleRouteChange();

    window.addEventListener("hashchange", handleRouteChange);

    return () => {
      window.removeEventListener("hashchange", handleRouteChange);
    };
  }, [menu]);


  const findSelectedKeyByPath = (menuItems, path) => {

    const menus = menuItems?.reduce((p, c) => {
      if (!_.isEmpty(c.children)) {
        return [...p, c, ...c.children]
      } else {
        return [...p, c]
      }
    }, [])

    const getPathPrefix = (path) => {
      if (!path) return
      if (menus?.find(m => m?.url == path)) {
        return menus?.find(m => m?.url == path)
      } else {
        return getPathPrefix(path?.substring(0, path?.lastIndexOf("/")))
      }
    }
    return getPathPrefix(path)
  };
  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <Menu
        openKeys={openKeys}
        selectedKeys={selectedKeys}
        onSelect={onSelect}
        onOpenChange={onOpenChange}
        mode={mode}
        className={`front-menu ${collapsed ? 'menu-collapsed' : ''}`}
        _internalDisableMenuItemTitleTooltip={true}
        triggerSubMenuAction={trigger}
        inlineCollapsed={collapsed}
        style={{
          ...(collapsed ? {} : { width })
          , backgroundColor: bgColor, lineHeight: `${itemHeight}px`, borderRight: 0
        }}>

        {GetMenu(value)}
      </Menu>
      {mode == 'inline' || mode == 'vertical' ? (inlineCollapsed ? (collapsed ? <RightOutlined onClick={onToggleCollapsed} style={{ width: collapsed ? '80px' : width, position: 'absolute', bottom: '10px' }} />
        : <LeftOutlined onClick={onToggleCollapsed} style={{ width: collapsed ? '80px' : width, position: 'absolute', bottom: '10px' }} />) : ''

      ) : ''
      }

      <style>{`.dashboar_menu_popup>ul.ant-menu{
        background:${bgColor};
        }
        .front-menu .ant-menu-sub li{
        height:${childItemMargin}px !important;
        line-height:${childItemMargin}px !important;
        }
        .front-menu .ant-menu-sub{
          height:${childItemHeight}px !important;
          overflow: hidden auto !important;
        }
        .front-menu.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected{
          border-bottom: none !important;
        }
        `}</style>
    </div>
  )
}

const FrontMenuComponent = props => {
  const {
    mode = 'horizontal', bgColor, editMode, icon, width, itemHeight, cellKey,
    itemMargin, textSize, textColor, menu, childItemMargin, childItemHeight, trigger, inlineCollapsed, defaultOpenKeys, accordion
  } = props

  const update = app?.context?.recoil?.useDataSet('customVar')
  const data = app?.context?.recoil?.useDataValue('customVar')
  if (!data?.menuforIfram) {
    update((state) => {
      return {
        ...state,
        ['menuforIfram']: '/'
      }
    })
  }
  return (<MainMenu
    name={'frontmenu'}
    menu={menu}
    update={update}
    data={data}
    cellKey={cellKey}
    mode={mode == '水平' ? 'horizontal' : mode == '垂直' ? 'inline' : mode}
    config={{ icon, width, bgColor, textColor, itemHeight, itemMargin, textSize, childItemMargin, childItemHeight, trigger }}
    canClick={!editMode}
    editMode={editMode}
    inlineCollapsed={inlineCollapsed}
    defaultOpenKeys={defaultOpenKeys}
    accordion={accordion}
  />)
}

const paramSchema = () => ({
  type: 'object',
  properties: {
    menu: {
      type: 'object',
      title: '菜单设置',
      properties: {}
    },
    mode: {
      type: 'string',
      title: '方向',
      enum: ['vertical', 'horizontal', 'inline'],
      enum_title: ['垂直', '水平', '内嵌']
    },
    inlineCollapsed: {
      type: 'boolean',
      title: '展开折叠',
      field: {
        formEffect: (form, { field }) => {
          const fkey = field.key.replace('inlineCollapsed', 'mode')
          form.useField(fkey, ({ value }) => {
            if (value == 'inline' || value == 'vertical') {
              form.setFieldData(field.name, { display: true })
            } else {
              setTimeout(() => { form.setFieldData(field.name, { display: false }) }, 0)
            }
          })
        }
      },
    },
    accordion: {
      type: 'boolean',
      title: '手风琴效果',
      description: '开启手风琴效果，只允许一个父级菜单为展开状态',
      field: {
        effect: (f, form) => {
          const { initialValues, values } = form.getState()
          if (f.value && _.isArray(values?.defaultOpenKeys)) {
            form.change('defaultOpenKeys', null)
          }
        }
      }
    },
    defaultOpenKeys: {
      type: 'string',
      title: '默认展开',
      description: '开启手风琴效果，默认展开只允许一个父级菜单',
      field: {
        component: props => <SelectMenu {...props} />
      },
    },
    trigger: {
      type: 'string',
      title: '触发方式',
      enum: ['click', 'hover'],
      enum_title: ['点击', '经过']
    },
    icon: {
      title: '显示图标',
      type: 'boolean',
    },
    bgColor: {
      title: '背景色',
      type: 'string',
      fieldType: 'color'
    },
    width: {
      title: '整体宽度',
      type: 'string',
      fieldType: 'unit'
    },
    itemHeight: {
      title: '选项高度',
      type: 'number',
    },
    itemMargin: {
      title: '选项间距',
      type: 'number',
    },
    textSize: {
      title: '字号',
      type: 'number',
    },
    textColor: {
      title: '文字颜色',
      type: 'string',
      fieldType: 'color'
    },
    childItemHeight: {
      title: '子菜单高度',
      type: 'number',
    },

    childItemMargin: {
      title: '子菜单选项高度',
      type: 'number',
    },

  },
  form: [{ key: 'menu', component: SettingsMenuField }, '*'],
  formEffect: form => {
    form.useField('mode', state => {
      let value = state.value
      if (value == 'inline') {
        form.setFieldData('defaultOpenKeys', { display: true })
        form.setFieldData('accordion', { display: true })
      } else {
        form.setFieldData('defaultOpenKeys', { display: false })
        form.setFieldData('accordion', { display: false })
      }
      if (value == 'vertical' || value == 'horizontal') {
        form.change('defaultOpenKeys', null)
      }
    })
  },
})

const FrontMenu = {
  title: '菜单',
  category: '页面元素',
  icon: require('../icon/菜单.svg'),
  component: FrontMenuComponent,
  initLayout: { width: 100, height: 80 },
  initParam: { mode: '水平', icon: true },
  paramSchema,
  theme: [
    { selector: '.ant-menu', title: '菜单样式' }
  ]
}
export default FrontMenu
